import React, { useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { Box, Button, Stack, Switch, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { Publish } from '@mui/icons-material';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { getManageAppraisalData, publishReport } from '../../../../../redux/features/appraisalSlice';


const PublishReport = ({ id, status, disabled, cycleId }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.appraisal);

  const handlePublish = async () => {
    const newStatus = status === false ? 1 : 0;
    try {
      const res = await dispatch(publishReport({ id, status: newStatus }));
      if (res?.payload?.status === 'success') {
        enqueueSnackbar(res.payload.message, { variant: 'success' });
        dispatch(getManageAppraisalData(cycleId)); // Refresh data after publishing
        setOpen(false);
      } else {
        enqueueSnackbar(res?.payload?.message || 'Failed to change publish status', { variant: 'error' });
      }
    } catch (err) {
      enqueueSnackbar('Something went wrong while publishing report', { variant: 'error' });
    }
  };

  return (
    <GlobalDialog
      title={'Publish Report'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'xs'}
      closeButton={true}
      popupButton={
        <Button disabled={disabled} variant='contained' color='secondary' startIcon={status === false ? <Publish /> : null} size="small" onClick={() => setOpen(true)}>
          {status === false ? 'Publish' : 'Unpublish'}
        </Button>
      }
      content={
        <>
          <Box display={'flex'} flexDirection={'column'} gap={2} >
            <Typography variant="body1">Are you sure you want to {status === false ? 'publish' : 'unpublish'} the report?</Typography>
            <Stack direction={'row'} gap={2} justifyContent={'flex-end'}>
            <Button variant="contained" color="primary" size="small" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button variant="contained" color="secondary" size="small" onClick={() => handlePublish()} disabled={loading}>
              {status === false ? 'Publish' : 'Unpublish'}
            </Button>
            </Stack>
          </Box>
        </>
      }
    />
  );
};

export default PublishReport;
